import {_ReactPixi, applyDefaultProps, PixiComponent} from '@inlet/react-pixi';
import {FullScreenFaderOptions, FullScreenFader as FullScreenFaderClass} from '@gongxigames/framework/core/fragments/display';
import {ScreenParameters} from '@gongxigames/framework/core/fragments/ScreenParameters';

export type FullScreenFaderProps = _ReactPixi.IGraphics &
    Omit<FullScreenFaderOptions, 'screenParameters'> &
    {
            screenParameters: ScreenParameters;
    };

export const FullScreenFader = PixiComponent<FullScreenFaderProps, FullScreenFaderClass>('FullScreenFader', {
    create(props: FullScreenFaderProps): FullScreenFaderClass {
        return new FullScreenFaderClass(props);
    },

    applyProps(instance: FullScreenFaderClass, oldProps: FullScreenFaderProps, newProps: FullScreenFaderProps): void {
        applyDefaultProps(instance, oldProps, newProps);

        const screenParametersOld = oldProps.screenParameters;
        const screenParametersNew = newProps.screenParameters;

        if (!screenParametersOld || !screenParametersNew.isEqual(screenParametersOld)) {
            instance.resize(newProps.screenParameters);
        }
    }
});
